<template>
  <div class="keyword-cloud__wrapper"
       :class="{'keyword-cloud__wrapper_no-data': isDataAbsent}">
    <div v-if="isDataAbsent" class="keyword-cloud__no-data">Awaiting Data</div>
    <div v-else-if="!this.isWordsFetched"
         class="keyword-cloud__loader-wrap">
      <base-horizontal-loader class="keyword-cloud__loader"/>
    </div>

    <vue-word-cloud
      v-else
      v-stop-draggable
      class="keyword-cloud"
      :words="words"
      :color="colorHandler"
      :font-weight="fontHandler"
      :spacing="2"
      :font-size-ratio="5"
      font-family="Roboto"
    />
  </div>
</template>

<script>
import VueWordCloud from 'vuewordcloud'
import { mapState } from 'vuex'

/**
 * Component for world cloud
 * Uses 'vuewordcloud' library
 */
export default {
  name: 'KeywordCloud',
  components: {
    // the library stuff
    [VueWordCloud.name]: VueWordCloud
  },
  data () {
    return {
      weights: []
    }
  },
  computed: {
    ...mapState('briefContent', {
      words (state) {
        let words = state.briefContent.words
        // we show only first 25 words. In other case the library slows down
        // pay attention: words are sorted in BE. If it changes in future - we need to add sorting here
        words = words.slice(0, 25)
        // weight - set of all score values present in response
        this.weights = words.reduce((acc, item) => {
          if (!acc.includes(item[1])) {
            acc.push(item[1])
          }
          return acc
        }, [])
        this.weights.sort()
        return words
      },
      isWordsFetched (state) {
        return state.briefContent.isWordsFetched
      }
    }),
    isDataAbsent () {
      return this.isWordsFetched && this.words.length === 0
    },
    briefId () {
      return this.$route.params.id
    }
  },
  methods: {
    /**
     * callback that changes font color depending on word weight (score value)
     * @param string - word
     * @param score - score value
     * @returns {string} - color of word
     */
    colorHandler ([string, score]) {
      const position = this.weights.findIndex(item => item === score)
      let opacity = 1
      // if word placed in first upper quarter of list it will have opacity 1
      if (position > (this.weights.length * 0.75)) {
        opacity = 1
        // if word placed in second upper quarter of list it will have opacity 0.7
      } else if (position > (this.weights.length * 0.5)) {
        opacity = 0.7
      } else {
        // other words will have opacity 0.5
        opacity = 0.5
      }
      return `rgba(49, 68, 167, ${opacity})`
    },
    fontHandler ([string, score]) {
      const position = this.weights.findIndex(item => item === score)
      let weight = 300
      // if word placed in first upper quarter of list it will have font-weight 900
      if (position > (this.weights.length * 0.75)) {
        weight = 900
        // if word placed in second upper quarter of list it will have font-weight 500
      } else if (position > (this.weights.length * 0.5)) {
        weight = 500
      } else {
        // other words will have font-weight 300
        weight = 300
      }
      return weight
    }
  }
}
</script>

<style scoped lang="scss">
  .keyword-cloud {
    width: 100%;

    &__no-data {
      display: flex;
      height: 100%;
      background-color: #fff;
      border-radius: $rfx-default-border-radius;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
    }

    &__wrapper {
      height: 200px;
      width: 100%;
      padding: 10px;
      box-sizing: border-box;

      &_no-data{
        height: auto;
      }
    }

    &__loader-wrap {
      height: 100%;
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      padding: 0;
      position: relative;
      display: flex;
      align-items: center;
    }

    &__loader {
      position: absolute;
      top: -2px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
</style>
